var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarSharing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 320,
    viewBox: "30 30 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.441 275.705c-64.147 0-116.152-52.004-116.152-116.15 0-64.146 52.005-116.15 116.152-116.15 64.147 0 116.152 52.004 116.152 116.15 0 64.146-52.005 116.15-116.152 116.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.29 91.406c-16.016 0-29-12.985-29-29 0-16.016 12.984-29 29-29 16.015 0 29 12.984 29 29 0 16.015-12.985 29-29 29zM217.29 90.406c-16.016 0-29-12.985-29-29 0-16.016 12.984-29 29-29 16.015 0 29 12.984 29 29 0 16.015-12.985 29-29 29z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39 22)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M168.329 162.665a8.187 8.187 0 01-8.188-8.188 8.187 8.187 0 018.188-8.188 8.187 8.187 0 018.188 8.188 8.187 8.187 0 01-8.188 8.188m-95.286 0c-4.523 0-8.193-3.665-8.193-8.188 0-4.523 3.67-8.188 8.193-8.188a8.187 8.187 0 018.188 8.188 8.187 8.187 0 01-8.188 8.188m95.327-26.389H73.001c-11.895 0-21.536 9.642-21.536 21.537v10.844c0 11.895 9.641 21.542 21.536 21.542h95.37c11.894 0 21.536-9.647 21.536-21.542v-10.844c0-11.895-9.642-21.537-21.537-21.537"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.777,
    x2: 170.777,
    y1: 181.613,
    y2: 203.924,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 26.143
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M160.345 135.419H81.028c-1.83 0-3.054-2.437-2.317-4.606l8.371-24.617c.403-1.186 1.313-1.955 2.317-1.955h62.575c.999 0 1.909.769 2.311 1.955l8.371 24.617c.737 2.17-.48 4.606-2.31 4.606m13.128-.183L162.944 99.1c-.513-1.74-1.647-2.87-2.913-2.87H81.336c-1.26 0-2.4 1.124-2.907 2.87L67.9 135.236c-.926 3.184.611 6.76 2.907 6.76h99.756c2.3 0 3.838-3.576 2.912-6.76"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.591,
    x2: 70.591,
    y1: 181.613,
    y2: 203.924,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 26.143
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M180.055 41.2h-7.969v12.868h7.995c1.427 0 2.65-.162 3.676-.492 1.02-.324 1.86-.784 2.525-1.375a5.477 5.477 0 001.454-2.118c.313-.815.465-1.715.465-2.692 0-1.914-.675-3.42-2.024-4.528-1.349-1.109-3.393-1.663-6.122-1.663M182.35 37.177c1.03-.309 1.882-.738 2.567-1.287a5.131 5.131 0 001.506-2.002 6.6 6.6 0 00.491-2.562c0-2.165-.653-3.754-1.96-4.769-1.308-1.02-3.336-1.521-6.087-1.521h-6.781v12.606h6.604c1.406 0 2.63-.152 3.66-.465"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M192.263 51.795a9.178 9.178 0 01-2.525 3.33c-1.109.921-2.468 1.643-4.079 2.15-1.605.512-3.44.758-5.5.758h-13.072V21.088h11.78c2.27 0 4.225.225 5.867.674 1.642.445 2.99 1.083 4.047 1.904a7.572 7.572 0 012.347 3.032c.508 1.197.758 2.541.758 4.037 0 .91-.14 1.783-.423 2.63a7.737 7.737 0 01-1.286 2.342c-.58.727-1.302 1.37-2.17 1.935-.868.564-1.888 1.03-3.054 1.396 2.698.528 4.732 1.5 6.113 2.907 1.375 1.411 2.06 3.268 2.06 5.573 0 1.558-.288 2.991-.863 4.277M178.6 8.435c-16.957 0-30.702 13.746-30.702 30.702 0 16.956 13.745 30.707 30.702 30.707 16.956 0 30.702-13.75 30.702-30.707 0-16.956-13.746-30.702-30.702-30.702M75.238 57.376c-.444 0-.81-.11-1.082-.334a2.07 2.07 0 01-.622-.858l-3.451-8.92h-16.58l-3.456 8.92c-.12.314-.324.591-.617.831-.293.241-.654.361-1.082.361h-3.87l14.776-36.945h5.077l14.776 36.945h-3.869zM61.361 10.073c-16.956 0-30.702 13.746-30.702 30.708 0 16.956 13.746 30.702 30.702 30.702 16.957 0 30.703-13.746 30.703-30.702 0-16.962-13.746-30.708-30.703-30.708z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M61.779 25.147a51.379 51.379 0 01-.555 1.945 25.64 25.64 0 01-.528 1.563l-5.798 15.001H68.69l-5.804-15.027c-.376-.93-.748-2.086-1.108-3.482M228.21 136.361h10.456c-.078-25.27-8.004-49.342-22.974-69.624a5.219 5.219 0 00-7.31-1.103 5.219 5.219 0 00-1.103 7.31c13.631 18.472 20.852 40.396 20.93 63.417M13.161 136.361c.079-23.183 7.388-45.222 21.192-63.768a5.232 5.232 0 00-1.072-7.32 5.24 5.24 0 00-7.315 1.072C10.81 86.711 2.783 110.914 2.704 136.361h10.457z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10.457,
    d: "M102.833 25.364a113.485 113.485 0 0117.85-1.407c6.087 0 12.058.481 17.883 1.407"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10.457,
    points: ".001 77.216 31.001 67.747 40.47 98.752"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10.457,
    points: "119.227 -.001 140.104 24.799 115.305 45.671"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10.457,
    points: "253.056 109.817 233.563 135.72 207.661 116.227"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSharing);
export default __webpack_public_path__ + "static/media/carSharing.6952042d.svg";
export { ForwardRef as ReactComponent };